export {};

const stopVideo = () => {
    $('video').each(function() {
        if (!this.paused) {
            this.pause();
            this.currentTime = 0;
        }
    });
};

NLMK.initMediaPopup = init;

function init() {
    const toLeft = e => {
        e.preventDefault();

        $('.mfp-container > .mfp-arrow.mfp-arrow-left.mfp-prevent-close').trigger('click');
    };

    const toRight = e => {
        e.preventDefault();

        $('.mfp-container > .mfp-arrow.mfp-arrow-right.mfp-prevent-close').trigger('click');
    };

    const setEvents = () => {
        $('body').on('click', '.mfp-content .js-left', toLeft);
        $('body').on('click', '.mfp-content .js-right', toRight);
    };

    const unsetEvents = () => {
        $('body').off('click', toLeft);
        $('body').off('click', toRight);
    };

    $('.media-popup').magnificPopup({
        key: 'my-popup',
        mainClass: 'mfp-media-gallery',
        gallery: {
            enabled: true,
            arrowMarkup: '<button title="%title%" type="button" class="mfp-arrow mfp-arrow-%dir%"><svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" viewBox="0 0 60 16.9"><polygon points="60,7.6 3.3,7.6 9.8,1.2 8.6,0 0,8.5 8.4,16.9 9.6,15.7 3.1,9.3 60,9.3 "/></svg></button>', // markup of an arrow button
        },
        callbacks: {
            markupParse: (template, values, item) => {
                // optionally apply your own logic - modify "template" element based on data in "values"
                // console.log('Parsing:', template, values, item);
            },

            open: () => {
                setEvents();
                $('html').addClass('no-scroll no-scroll-ios');
                $('body').addClass('no-scroll no-scroll-ios');
            },

            change: function () {
                this.content.find('.js-value-slides').text(this.items.length);
                this.content.find('.js-current-slide').text(this.currItem.index + 1);
                stopVideo();
            },

            close: () => {
                unsetEvents();
                $('html').removeClass('no-scroll no-scroll-ios');
                $('body').removeClass('no-scroll no-scroll-ios');
                stopVideo();
            }
        }
    });
}

$(document).ready(function() {
    init();
});

// const $items = $(document).find('.js-popup-item');

// let $valueAll = $items.find('.js-value-slides');
// let $valueCurrent = $items.find('.js-current-slide');


// const $popup = $(document).find('.js-popup');
// const $openImg = $(document).find('.js-card-item');
// const $btnClose = $popup.find('.js-btn-close-popup');

// const $slider = $popup.find('.js-popup-slider');
// const $slides = $popup.find('.js-popup-slide');
// const $btnLeft = $popup.find('.js-popup-left');
// const $btnRight = $popup.find('.js-popup-right');

// let currentIndex = 0;

// $('body').on('click', '.js-card-item', e => {
//     e.preventDefault();

//     $popup.addClass('is-open');
// });

// $btnClose.on('click', () => {
//     $popup.removeClass('is-open')
// })

// $btnLeft.on('click', e => {
//     e.preventDefault();
//     console.log($slides.eq(currentIndex).position().left)

//     currentIndex--;

//     if (currentIndex < 0) {
//         currentIndex = 0;
//     }

//     const posLeft = $slider.position().left;
//     const newX = $slides.eq(currentIndex).position().left;

//     $slider.scrollLeft(newX - posLeft);

//     console.log('qweqweqw')

// });

// $btnRight.on('click', e => {
//     e.preventDefault();

//     console.log($slides.eq(currentIndex).position().left);
//     currentIndex++;

//         if (currentIndex > $slides.length - 1) {
//             currentIndex = $slides.length - 1;
//         }

//         const newX = $slides.eq(currentIndex).position().left;

//         $slider.scrollLeft(newX)
// });



// WEBPACK FOOTER //
// ./js/main/module/media-popup.js